import axios from 'axios'
import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
  }

  disconnect() {
  }

  hide(e) {
    e.preventDefault()
    axios.put(e.target.href).then(() => {
      e.target.closest('tr').innerHTML = ''
    })
  }

}